import { render, staticRenderFns } from "./PerformanceTargetResultCalculationCard.vue?vue&type=template&id=2c0fdf47"
import script from "./PerformanceTargetResultCalculationCard.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetResultCalculationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports